// ============================================================================
// STAY EXTENSION ENDPOINTS
// ============================================================================

import { buildEndpointWithParams, buildEndpointWithQuery } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/StayExtension';

export const stayExtensionEndpoints = {
  /** GET /api/v1/StayExtension/preview/{bookingId}?newCheckOutDate=… */
  preview: (bookingId: ID, newCheckOutDate: string) =>
    buildEndpointWithQuery(
      `${BASE_PATH}/preview/${bookingId}`,
      { newCheckOutDate },
    ),
  /** POST /api/v1/StayExtension/{bookingId} — commits the extension. */
  extend: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:bookingId`, { bookingId }),
} as const;

export default stayExtensionEndpoints;
